<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" clearable :placeholder="`${$t('menu.OrderNumber')}/${$t('menu.chejiahao')}`"
          v-model="formInline.title"></el-input>
      </el-form-item>
     
        
      
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
        <!-- <el-button>重置</el-button> -->
      </el-form-item>
    </el-form>
    <div class="bonntbot">
      <el-tabs v-model="action" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in staue" :key="index"
          :label="item.num > 0 ? item.name + '(' + item.num + ')' : item.name" :name="item.id"></el-tab-pane>


      </el-tabs>
      <div class="bonntbota">
     
      </div>

    </div>
    <el-table  empty-text=" " :data="mation" style="width: 100%" border highlight-current-row @selection-change="handleSelectionChange">
      <!-- <el-table-column type="selection" width="70">
      </el-table-column> -->
      <el-table-column prop="pc" :label="$t('menu.ClaimNumber')" width="200">
        <template slot-scope="scope">
        <div>  {{ scope.row.claimNumber }}</div>
          </template>
      </el-table-column>
      
      <el-table-column prop="vin" :label="$t('menu.chejiahao')"  ></el-table-column>
      <el-table-column prop="partNumber" :label="$t('menu.cgwdpjbm')"   > </el-table-column>
      <el-table-column prop="partName" :label="$t('menu.PartName')">
        <template slot-scope="scope">
          <div v-if="inle=='zh'">
           {{ scope.row.partName }}
          </div>
          <div v-else>
             {{ scope.row.partNameEn }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" :label="$t('menu.suopeishukl')">  </el-table-column>
      <el-table-column prop="orderQuanity" :label="$t('menu.yipeifusl')"> 
          <template slot-scope="scope">
       
              {{ scope.row.orderQuanity==null?0:scope.row.orderQuanity }}
        
            </template> </el-table-column>
        <el-table-column prop="quantity" :label="$t('menu.dipeifusl')"> 
           <template slot-scope="scope">
          <div v-if="scope.row.orderQuanity!==null">
              {{ scope.row.quantity-scope.row.orderQuanity }}
          </div>
            <div v-else>
              {{ scope.row.quantity}}
            </div>
            </template>
           </el-table-column>
           <el-table-column   prop="poNum" :label="$t('menu.xiaoshoudh')"> 
             <template slot-scope="scope">
          <div v-if="scope.row.poNum!==null">
              {{ scope.row.poNum }}
          </div>
            <div v-else>
             -
            </div>
            </template>
             </el-table-column>
      <el-table-column prop="status" :label="$t('menu.State')" width="80">
        <template slot-scope="scope">
          {{ formatStatus(scope.row.status) }}
        </template>
      </el-table-column>
     
    
    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>
    </div>

    <div></div>
  </div>
</template>

<script>
import { pomyPos,cartCoOfDealerlist, querytype, pageSumMyPo, exportMyPo, exportMyPoDetails,retailerlist } from '../../api/api'

export default {
  data () {
    return {
      action: '99',
      staue: [
        {
          name: this.$t('menu.All'),
          num: 0,
          id: '99',
        },
        {
          name: this.$t('menu.dailipei'),
          num: 0,
          id: '0',
        },
        {
          name: this.$t('menu.yilipei'),
          num: 0,
          id: '1',
        },
        {
          name: this.$t('menu.quxiaolip'),
          num: 0,
          id: '2',
        }],
      jsfs: [],
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
      orderType:'',
      mation: [], //列表
      formInline: {
        title: '',
        startTime: '',
        endTime: '',
        contact: '',
        category: '',
        type: '',
        staue: '',
        data1: '',
        data2: '',
        
      },
      inle: 'zh',
      odtype:'',
      lslis:[],
    }
  },
  created () {
    let a = sessionStorage.getItem('i18n')
    this.inle = a
    this.querytyp()
    this.action = '99'
    this.biao()
  },
  methods: {
   
   
    async biao () {
      let a = ''
      if (this.action == '99') {
        a = ''
      } else {
        a = this.action
      }
      console.log(123123,this.orderType);
        let status = a
         let param = new URLSearchParams()
      let parama ='?pageNum=' +  this.currentPage3+'&pageSize='+this.pagesize+'&status='+status+'&searchValue='+this.formInline.title
      
      const { data: res } = await cartCoOfDealerlist(param,parama )

     console.log(res);
     
 this.mation = res.rows
 this.totale=res.total
if(res.summary.length>0){
    res.summary.forEach(ez=>{
  this.staue.forEach(ea=>{
    if(ez.status==ea.id){
      ea.num=ez.sum
    }
 })
 })
 }
 
console.log(123123, this.mation); 
      this.lsslist()
   
      // this.numlist()
    },
    async numlist () {

      let param = {}
      const { data: res } = await pageSumMyPo(param)
      let a = this.staue
      let b = 0
      let c = 0
      res.data.forEach(e => {
        a.forEach((z, i) => {
          if (e.status == z.id) {
            this.staue[i].num = e.sum
          } else {
            if (e.status == 5) {
              console.log(1);

              b = e.sum
            }
            if (e.status == 1) {
              console.log(1);

              c = e.sum
            }
          }


        })


      })
      this.staue[1].num = b + c
    },
   async lsslist(){
      
        let param = new URLSearchParams()
      const { data: res } = await retailerlist(param, 1,1000)
      console.log(res.rows);
    this.lslis=res.rows
      
    },


    handleSelectionChange () { },
    async querytyp () {
      let param = new URLSearchParams()
      const { data: res } = await querytype(param, 't_po_payment_method')
      this.jsfs = res.data
      this.jsfs.unshift({
        dictLabel: this.$t('menu.All'),
        dictValue: '',
        dictLabelEn: this.$t('menu.All'),
      })
      this.odtype=[
        {
          dictLabel: this.$t('menu.All'),
        dictValue: '',
        dictLabelEn: this.$t('menu.All'),
        },
        { 
          dictLabel: this.$t('menu.Partsorder'),
        dictValue: '1',
        dictLabelEn: this.$t('menu.Partsorder'),
        },
        {
          dictLabel: this.$t('menu.Vehicleorder'),
        dictValue: '2',
        dictLabelEn: this.$t('menu.Vehicleorder'),
        },
      ]
    },
    handleClick (tab, event) {
      this.action = tab.name
      this.biao()
      // console.log(tab, event)
    },
    //表单点击
    handleEdit (index, row) {
      let a = sessionStorage.getItem('name')
      let b = sessionStorage.getItem('namef')
      sessionStorage.setItem('namefac1',a )
      sessionStorage.setItem('namefac2',b )
      let cc  =sessionStorage.getItem('i18n')
      if (cc == 'zh') {
        sessionStorage.setItem('name', '订单详情')
        sessionStorage.setItem('namef', 'Details')

      } else {
        sessionStorage.setItem('name', 'Details')
        sessionStorage.setItem('namef', '订单详情')
      }
    
      this.$router.push({
        path: '/orderDetails',
        query: {
          vin: row.vin,
          type: index,
          orderNumber: row.po.orderNumber,
        },
      })
    },
    //tab切换
    tabclick (i) {
      console.log(i);

      // this.action = i
      // this.biao()
    },

    //搜索
    onSubmit () {
      this.biao()
    },

    handleSizeChange (val) {
      this.pagesize = val
      console.log(`每页 ${val} 条`)
      this.biao()
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.biao()
    },
    jstype (e) {
      let c = ''
      let a = this.jsfs
      a.forEach((z) => {
        if (e == z.dictValue && this.inle == 'zh') {
          c = z.dictLabel
        }
        if (e == z.dictValue && this.inle !== 'zh') {
          c = z.dictLabelEn
        }
      })
      return c
    },
    formatStatus (status) {
      if (status == 0) {
        return this.$t('menu.dailipei')
      } else if (status == 1) {
        return this.$t('menu.yilipei')
      } else if (status == 2) {
        return this.$t('menu.quxiaolip')
      } 
    },
  },
}
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;


  position: relative;


}

.bonntbota {
  position: absolute;
  right: 10px;
  top: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
  font-size: 16px;
  font-weight: 600;
}
</style>
